import { DefaultService } from '@/services/DefaultService';


export default class AssCampanhaClienteService extends DefaultService {
  constructor(http, router, env) {
    super(http, router, env);
  }

  findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/campanha.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/agro/cliente/campanha.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  updateSituacaoVendas(campanha) {
    return this._http.post(`${this._env}/ven/cliente/campanha/updatesituacao`, campanha, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  updateSituacaoAgro(campanha) {
    return this._http.post(`${this._env}/agro/cliente/campanha/updatesituacao`, campanha, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/campanha/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/agro/cliente/campanha/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  saveVendas(lista) {
    return this._http.post(`${this._env}/ven/cliente/campanha`, lista, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  saveAgro(lista) {
    console.log(lista);
    return this._http.post(`${this._env}/agro/cliente/campanha`, lista, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  saveAssVendas(lista) {
    return this._http.post(`${this._env}/ven/cliente/campanha/save`, lista, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }
  saveAssAgro(lista) {
    return this._http.post(`${this._env}/agro/cliente/campanha/save`, lista, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }
}